// GÓI SEEDING (docs/thiet-ke-goi-seeding.md): danh sách gói có sẵn + "Gói của bạn", trình hướng dẫn 4 bước (#/goi-seeding/moi) và trang một gói
// đã dùng (#/goi-seeding/:id). Người dùng chọn SẢN PHẨM, chọn MẠNG, chỉnh LỜI VĂN (để tự do — không khoá điều nào) và TẦN SUẤT chạy; máy chủ tạo
// kịch bản Nháp + lịch TẮT. Mọi chữ dựng bằng textContent (ký tự ' " < & \ và emoji hiện đúng dạng chữ).
// Quy ước: kiểm hợp lệ bằng chính kiemCauHinh của máy chủ (src/shared/goi-seeding.ts) nên lỗi báo ở web = lỗi máy chủ sẽ báo; bản nháp của
// trình hướng dẫn giữ trong sessionStorage (F5 không mất); yeuCauId cố định cho một phiên → bấm "Tạo" hai lần chỉ ra một bản.
import { api, ApiError, buildQuery, errMsg } from "../api";
import { clear, confirmBox, gen, h, toast } from "../dom";
import { fmtTime } from "../format";
import { store } from "../store";
import type { GoiBotView, GoiDungChiTiet, GoiDungLich, GoiDungTomTat, GoiKichBanView, GoiLichTinhTrang, GoiMangView, GoiView, Mang } from "../types";
import {
  CACH_BOT_TOI_THIEU, GIOI_HAN_GOI, LECH_TOI_DA, LOAI_TEN, MANG, MANG_TEN, TOI_DA_BOT_KB, TOI_DA_KHUNG, botIdsCuaLich, doiTenSanPhamTrongLoiVan, gioTheoBot, kiemCauHinh, loiVanLaMacDinh, loiVanMacDinh,
  type CauHinhGoi, type GoiDef, type KbGoi, type LoiVan, type ThamSoMang,
} from "../../../../src/shared/goi-seeding";
import { TEN_NHAN, type Nhan } from "./kich-ban-nhan";
import { oAnhChon } from "./chon-anh"; // (05/10/2026) chọn ảnh / album trong Kho ảnh cho kịch bản bật kèm ảnh

const NGAY = ["T2", "T3", "T4", "T5", "T6", "T7", "CN"];
const NGAY_DAY = ["Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy", "Chủ nhật"];
const CA_TUAN = [1, 2, 3, 4, 5, 6, 7];
const CANH_BAO_DUYET = "Mỗi câu đăng/bình luận cần người duyệt trong 5 phút, không có ai duyệt thì bước đó bị bỏ.";
// (03/10/2026) Lựa chọn "Tự động (không cần duyệt)" theo từng kịch bản — mặc định TẮT, bật phải xác nhận.
const TU_DONG = "Tự động (không cần duyệt)";
const CANH_BAO_TU_DONG = "bot sẽ gửi/đăng mà không hỏi — bạn chịu trách nhiệm nội dung";
const dem = (s: string): number => Array.from(s).length;

// ---------------- kiểu bản nháp (giữ chữ gõ nguyên văn để báo lỗi đúng chỗ) ----------------
interface KhungNhap { id: string; gio: string; thu: number[]; lech: string; bat: boolean }
// (04/10/2026) NHIỀU bot cho mỗi kịch bản: botIds (thứ tự = thứ tự trong danh sách bot → giờ lệch xác định). Bản nháp cũ (botId đơn) đọc lại được.
interface LichNhap { botIds: string[]; moiNgay: string; khung: KhungNhap[] }
interface GhiDeNhap { giongDieu: string; mucTieu: string; camKy: string[] | null }
interface Nhap {
  v: 1; goiMa: string; yeuCauId: string; buoc: number;
  sanPhamId: string; sanPhamTen: string;
  mang: Mang[]; kichBanBat: string[];
  loiVan: LoiVan; loiVanSua: boolean;
  ghiDe: Partial<Record<Mang, GhiDeNhap>>;
  thamSo: Partial<Record<Mang, ThamSoMang>>;
  lich: Record<string, LichNhap>;
  tuDuyet?: string[]; // mã kịch bản đặt "Tự động (không cần duyệt)" (thiếu = không kịch bản nào)
  kemAnh?: string[]; // mã kịch bản bật "Bình luận kèm ảnh (từ kho ảnh sản phẩm)" (thiếu = không kịch bản nào)
  anhChon?: Record<string, string>; // (05/10/2026) mã kịch bản → ảnh / album chọn trong Kho ảnh (tham số anh_chon); thiếu = ảnh sản phẩm như trước
}

const maNgauNhien = (tien: string): string => `${tien}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
const maKhung = (): string => `m${Math.random().toString(36).slice(2, 8)}${Date.now().toString(36).slice(-4)}`;

/** GoiView (máy chủ gửi) → GoiDef (kiểu kiemCauHinh cần); phần "nut" web không dùng. */
function goiDefTuView(v: GoiView): GoiDef {
  return { ma: v.ma, phienBan: v.phienBan, ten: v.ten, moTa: v.moTa, kichBan: v.mang.flatMap((m) => m.kichBan.map((k): KbGoi => ({ ...k, mang: m.mang, nut: [] }))) };
}
const kbCuaGoi = (goi: GoiDef, ma: string): KbGoi | undefined => goi.kichBan.find((k) => k.ma === ma);

// ---------------- bản nháp trong sessionStorage ----------------
const khoaNhap = (): string => `goi-seeding:nhap:${store.user?.id ?? "?"}`;
function docNhap(): Nhap | null {
  try {
    const s = sessionStorage.getItem(khoaNhap());
    if (!s) return null;
    const n = JSON.parse(s) as Nhap;
    if (!n || n.v !== 1 || typeof n.goiMa !== "string" || typeof n.yeuCauId !== "string" || !Array.isArray(n.mang) || !Array.isArray(n.kichBanBat) || !n.loiVan || !n.lich) return null;
    for (const l of Object.values(n.lich)) if (l && !Array.isArray(l.botIds)) l.botIds = botIdsCuaLich(l as unknown as { botId?: string | null }); // bản nháp trước 04/10 (botId đơn)
    return n;
  } catch { return null; }
}
function luuNhap(n: Nhap): void { try { sessionStorage.setItem(khoaNhap(), JSON.stringify(n)); } catch { /* trình duyệt chặn lưu → vẫn dùng được, chỉ không giữ khi F5 */ } }
function xoaNhap(): void { try { sessionStorage.removeItem(khoaNhap()); } catch { /* bỏ qua */ } }

function nhapMoi(goi: GoiView): Nhap {
  return { v: 1, goiMa: goi.ma, yeuCauId: maNgauNhien("gs"), buoc: 1, sanPhamId: "", sanPhamTen: "", mang: [], kichBanBat: [], loiVan: loiVanMacDinh(""), loiVanSua: false, ghiDe: {}, thamSo: {}, lich: {} };
}

// ---------------- dựng cấu hình từ bản nháp + kiểm từng bước ----------------
const soNguyen = (s: string): number => (/^\d+$/.test(s.trim()) ? Number(s.trim()) : Number.NaN);
const kbDangBat = (n: Nhap, goi: GoiDef): KbGoi[] => goi.kichBan.filter((k) => n.mang.includes(k.mang) && n.kichBanBat.includes(k.ma));
const canCuaMang = (n: Nhap, goi: GoiDef, mang: Mang): Set<string> => new Set(kbDangBat(n, goi).filter((k) => k.mang === mang).flatMap((k) => k.can));
/** Tham số có ô nhập (bắt buộc + không bắt buộc) của các kịch bản đang bật trên một mạng. */
const oCuaMang = (n: Nhap, goi: GoiDef, mang: Mang): Set<string> => new Set(kbDangBat(n, goi).filter((k) => k.mang === mang).flatMap((k) => [...k.can, ...(k.tuyChon ?? [])]));

function lichMacDinh(kb: KbGoi, bots: GoiBotView[]): LichNhap {
  const bot = bots.find((b) => b.online && !b.tamDung) ?? null;
  return { botIds: bot ? [bot.id] : [], moiNgay: String(kb.moiNgay), khung: kb.khung.map((k) => ({ id: k.id, gio: k.gio, thu: [...k.thu], lech: String(k.lech), bat: false })) };
}
/** Bot "phù hợp" cho một mạng: không tạm dừng ở mạng đó; nếu có bot ĐÃ CHẠY mạng này thì chỉ các bot đó (chưa có dữ liệu → mọi bot không tạm dừng). */
export function botPhuHop(bots: GoiBotView[]): GoiBotView[] {
  const conDung = bots.filter((b) => !b.tamDung);
  const daChay = conDung.filter((b) => b.daChayMang);
  return daChay.length ? daChay : conDung;
}
function botCuaMang(view: GoiView, mang: Mang): GoiBotView[] { return view.mang.find((m) => m.mang === mang)?.bot ?? []; }
/** Điền lịch mặc định cho các kịch bản đang bật mà chưa có (giữ nguyên cái người dùng đã sửa). */
function khoiTaoLich(n: Nhap, goi: GoiDef, view: GoiView): void {
  for (const kb of kbDangBat(n, goi)) if (!n.lich[kb.ma]) n.lich[kb.ma] = lichMacDinh(kb, botCuaMang(view, kb.mang));
}

function taoCauHinh(n: Nhap, goi: GoiDef, voiLich: boolean): CauHinhGoi {
  const mang = MANG.filter((m) => n.mang.includes(m));
  const bat = kbDangBat(n, goi);
  const cfg: CauHinhGoi = {
    sanPhamId: n.sanPhamId,
    mang,
    kichBanBat: bat.map((k) => k.ma),
    loiVan: { giongDieu: n.loiVan.giongDieu.trim(), camKy: n.loiVan.camKy.map((x) => x.trim()).filter(Boolean), mucTieu: n.loiVan.mucTieu.trim() },
    thamSo: {},
    lich: {},
  };
  const lvm: NonNullable<CauHinhGoi["loiVanMang"]> = {};
  for (const m of mang) {
    const g = n.ghiDe[m];
    if (g) {
      const o: Partial<LoiVan> = {};
      if (g.giongDieu.trim()) o.giongDieu = g.giongDieu.trim();
      if (g.mucTieu.trim()) o.mucTieu = g.mucTieu.trim();
      if (g.camKy) o.camKy = g.camKy.map((x) => x.trim()).filter(Boolean);
      if (Object.keys(o).length) lvm[m] = o;
    }
    const can = oCuaMang(n, goi, m);
    const t = n.thamSo[m] ?? {};
    const ts: ThamSoMang = {};
    if (can.has("tuKhoa")) ts.tuKhoa = (t.tuKhoa ?? "").trim();
    if (can.has("chuDe")) ts.chuDe = (t.chuDe ?? "").trim();
    if (can.has("nhomUrl")) ts.nhomUrl = (t.nhomUrl ?? "").trim();
    if (can.has("tenTrang")) ts.tenTrang = (t.tenTrang ?? "").trim();
    if (Object.keys(ts).length) cfg.thamSo[m] = ts;
  }
  if (Object.keys(lvm).length) cfg.loiVanMang = lvm;
  const tuDong = (n.tuDuyet ?? []).filter((ma) => bat.some((k) => k.ma === ma));
  // LUÔN gửi khoá tuDuyet (kể cả {}): thiếu khoá = "chưa chọn" → máy chủ đặt Tự động mặc định khi TẠO gói; có khoá = Boss đã chọn (tắt tay vẫn tắt).
  cfg.tuDuyet = Object.fromEntries(tuDong.map((ma) => [ma, true]));
  const kemAnh = (n.kemAnh ?? []).filter((ma) => bat.some((k) => k.ma === ma));
  if (kemAnh.length) cfg.kemAnh = Object.fromEntries(kemAnh.map((ma) => [ma, true]));
  const anhChon = kemAnh.map((ma) => [ma, (n.anhChon?.[ma] ?? "").trim()] as const).filter(([, v]) => v);
  if (anhChon.length) cfg.anhChon = Object.fromEntries(anhChon);
  if (voiLich) {
    for (const kb of bat) {
      const ln = n.lich[kb.ma];
      if (!ln) continue;
      const moiNgay = ln.moiNgay.trim() === "" ? undefined : soNguyen(ln.moiNgay);
      cfg.lich[kb.ma] = {
        botIds: [...ln.botIds],
        ...(moiNgay === undefined ? {} : { moiNgay }),
        khung: ln.khung.map((k) => ({ id: k.id, gio: k.gio.trim(), thu: [...k.thu].sort((a, b) => a - b), lech: k.lech.trim() === "" ? 0 : soNguyen(k.lech), bat: k.bat })),
      };
    }
  }
  return cfg;
}

function loiBuoc(n: Nhap, goi: GoiDef, buoc: number): string[] {
  if (buoc === 1) return n.sanPhamId ? [] : ["Chưa chọn sản phẩm — bấm chọn một sản phẩm trong danh sách (chưa có thì thêm ở trang Sản phẩm)"];
  if (buoc === 2) {
    if (!n.mang.length) return ["Chọn ít nhất một mạng xã hội muốn quảng bá"];
    const loi: string[] = [];
    for (const m of MANG) if (n.mang.includes(m) && !kbDangBat(n, goi).some((k) => k.mang === m)) loi.push(`${MANG_TEN[m]}: chưa chọn kịch bản nào — bỏ chọn mạng này hoặc tick ít nhất một kịch bản`);
    return loi;
  }
  const l = loiBuoc(n, goi, 1).concat(loiBuoc(n, goi, 2));
  if (l.length) return l;
  return kiemCauHinh(goi, taoCauHinh(n, goi, buoc === 4));
}

/** Lỗi trả về từ máy chủ → danh sách dòng dễ đọc (400 có details.loi[] thì liệt kê từng lỗi). */
function loiTuMayChu(e: unknown): string[] {
  if (e instanceof ApiError && e.details && typeof e.details === "object") {
    const l = (e.details as { loi?: unknown }).loi;
    if (Array.isArray(l) && l.length) return l.map((x) => String(x));
  }
  return [errMsg(e)];
}
function hopLoi(testid: string): HTMLElement { return h("div", { class: "err-box goi-loi", role: "alert", hidden: true, "data-testid": testid }); }
function hienLoi(box: HTMLElement, dong: string[], tieuDe?: string): void {
  clear(box);
  if (!dong.length) { box.hidden = true; return; }
  if (tieuDe) box.append(h("div", { class: "goi-loi-tieu-de" }, tieuDe));
  box.append(h("ul", { class: "goi-loi-ds" }, dong.map((d) => h("li", { "data-testid": "goi-loi-dong" }, d))));
  box.hidden = false;
}

// ---------------- khối giao diện dùng chung (trình hướng dẫn + trang gói) ----------------
const demChu = (el: HTMLTextAreaElement | HTMLInputElement, hien: HTMLElement, toiDa: number): void => {
  const c = dem(el.value);
  hien.textContent = `${c}/${toiDa}`;
  hien.classList.toggle("err", c > toiDa);
};

/** Danh sách điều cấm: thêm / sửa / xoá TỰ DO (không khoá điều nào). */
function soanCamKy(ds: string[], thayDoi: () => void, testid: string): HTMLElement {
  const host = h("div", { class: "goi-cam-ky", "data-testid": testid });
  const ve = (): void => {
    clear(host);
    ds.forEach((x, i) => {
      const o = h("input", { value: x, placeholder: "Một điều cấm (ví dụ: không chèn link)", "data-testid": "goi-cam-ky", "aria-label": `Điều cấm ${i + 1}` });
      const dc = h("span", { class: "small muted goi-dem" });
      demChu(o, dc, GIOI_HAN_GOI.camKyMuc);
      o.addEventListener("input", () => { ds[i] = o.value; demChu(o, dc, GIOI_HAN_GOI.camKyMuc); thayDoi(); });
      const xoa = h("button", { type: "button", class: "mini", title: "Xoá điều cấm này", "data-testid": "goi-cam-ky-xoa", "aria-label": `Xoá điều cấm ${i + 1}`, onclick: () => { ds.splice(i, 1); thayDoi(); ve(); } }, "Xoá");
      host.append(h("div", { class: "goi-cam-ky-dong" }, o, dc, xoa));
    });
    const them = h("button", { type: "button", class: "mini", title: `Thêm một điều cấm (tối đa ${GIOI_HAN_GOI.camKy})`, "data-testid": "goi-cam-ky-them", onclick: () => { ds.push(""); thayDoi(); ve(); (host.querySelectorAll<HTMLInputElement>("input")[ds.length - 1])?.focus(); } }, "+ Thêm điều cấm");
    host.append(h("div", { class: "row" }, them, h("span", { class: "small muted" }, `${ds.filter((x) => x.trim()).length}/${GIOI_HAN_GOI.camKy} điều`)));
  };
  ve();
  return host;
}

function oChu(nhan: string, o: HTMLTextAreaElement | HTMLInputElement, toiDa: number, goiY?: string): HTMLElement {
  const dc = h("span", { class: "small muted goi-dem" });
  demChu(o, dc, toiDa);
  o.addEventListener("input", () => demChu(o, dc, toiDa));
  return h("label", { class: "f" }, h("span", {}, nhan, " ", dc), o, goiY ? h("span", { class: "small muted" }, goiY) : null);
}

interface NguCanhLoiVan { n: Nhap; goi: GoiDef; view: GoiView; thayDoi: () => void; veLai: () => void; tenSp: () => string }

/** Bước "Lời văn" — dùng cho trình hướng dẫn và cho thẻ sửa ở trang gói. */
function veLoiVan(c: NguCanhLoiVan): HTMLElement {
  const { n, goi } = c;
  const giong = h("textarea", { rows: 3, "data-testid": "goi-giong-dieu", class: "goi-ta", title: "Giọng điệu khi viết bình luận/bài: ai nói, nói thế nào" });
  giong.value = n.loiVan.giongDieu;
  giong.addEventListener("input", () => { n.loiVan.giongDieu = giong.value; n.loiVanSua = true; c.thayDoi(); });
  const muc = h("textarea", { rows: 2, "data-testid": "goi-muc-tieu", class: "goi-ta", title: "Mục tiêu: bạn muốn người đọc nhận được điều gì" });
  muc.value = n.loiVan.mucTieu;
  muc.addEventListener("input", () => { n.loiVan.mucTieu = muc.value; n.loiVanSua = true; c.thayDoi(); });
  const camKy = soanCamKy(n.loiVan.camKy, () => { n.loiVanSua = true; c.thayDoi(); }, "goi-cam-ky-ds");
  const khoiMang = h("div", { class: "goi-lv-mang", "data-testid": "goi-lv-mang" });
  const nutAi = h("button", { type: "button", class: "mini", "data-testid": "goi-ai-goi-y", title: "AI đọc hồ sơ sản phẩm của bạn rồi gợi ý từ khoá và chủ đề; chỉ điền vào các ô đang để trống" }, "AI gợi ý từ khoá");
  const ketQuaAi = h("p", { class: "small", hidden: true, "data-testid": "goi-ai-kq", role: "status" });
  nutAi.addEventListener("click", () => void (async () => {
    if (nutAi.disabled) return;
    if (!n.sanPhamId || !n.mang.length) { ketQuaAi.hidden = false; ketQuaAi.className = "small err"; ketQuaAi.textContent = "Cần chọn sản phẩm (bước 1) và ít nhất một mạng (bước 2) trước khi nhờ AI gợi ý."; return; }
    nutAi.disabled = true;
    const chu = nutAi.textContent;
    nutAi.textContent = "AI đang nghĩ…";
    ketQuaAi.hidden = false; ketQuaAi.className = "small muted"; ketQuaAi.textContent = "Đang hỏi AI…";
    try {
      const r = await api<{ tuKhoa: Partial<Record<Mang, string>>; chuDe: Partial<Record<Mang, string>>; nguon: "ai" | "mac_dinh" }>("POST", "/api/goi-seeding/goi-y", { sanPhamId: n.sanPhamId, mang: MANG.filter((m) => n.mang.includes(m)) });
      let dien = 0;
      for (const m of n.mang) {
        const can = canCuaMang(n, goi, m);
        const t = (n.thamSo[m] ??= {});
        if ((can.has("tuKhoa") || oCuaMang(n, goi, m).has("tuKhoa")) && r.tuKhoa[m] && !(t.tuKhoa ?? "").trim()) { t.tuKhoa = r.tuKhoa[m]; dien++; }
        if (can.has("chuDe") && r.chuDe[m] && !(t.chuDe ?? "").trim()) { t.chuDe = r.chuDe[m]; dien++; }
      }
      c.thayDoi();
      veMang();
      ketQuaAi.className = "small ok";
      ketQuaAi.textContent = `${r.nguon === "ai" ? "AI đã gợi ý" : "Máy đã rút từ khoá từ tên sản phẩm (AI chưa dùng được lúc này)"}: điền ${dien} ô trống${dien ? "" : " (các ô đều đã có chữ nên giữ nguyên)"}. Bạn xem và sửa lại cho đúng ý.`;
    } catch (e) {
      ketQuaAi.className = "small err";
      ketQuaAi.textContent = `Chưa gợi ý được: ${errMsg(e)}. Bạn vẫn có thể tự gõ từ khoá.`;
    } finally { nutAi.disabled = false; nutAi.textContent = chu; }
  })());

  function veMang(): void {
    clear(khoiMang);
    for (const m of MANG.filter((x) => n.mang.includes(x))) {
      const can = oCuaMang(n, goi, m);
      const batBuoc = canCuaMang(n, goi, m);
      const t = (n.thamSo[m] ??= {});
      const phan: HTMLElement[] = [];
      if (can.has("tuKhoa")) {
        const o = h("input", { value: t.tuKhoa ?? "", placeholder: "ví dụ: dựng video, phụ đề tự động", "data-testid": "goi-tu-khoa", dataset: { mang: m }, title: "Từ khoá để tìm bài/nhóm/video, cách nhau bằng dấu phẩy; mỗi từ khoá nên 1–3 chữ" });
        o.addEventListener("input", () => { t.tuKhoa = o.value; c.thayDoi(); });
        phan.push(oChu(`Từ khoá (${MANG_TEN[m]})${batBuoc.has("tuKhoa") ? "" : " — không bắt buộc"}`, o, GIOI_HAN_GOI.tuKhoa, batBuoc.has("tuKhoa") ? "Cách nhau bằng dấu phẩy, mỗi từ khoá nên chỉ 1–3 chữ (ví dụ: dựng video, phụ đề)." : "Cách nhau bằng dấu phẩy. Dùng để bot tự chọn nhóm hợp chủ đề khi để trống địa chỉ nhóm; để trống thì chọn theo chủ đề bài."));
      }
      if (can.has("chuDe")) {
        const o = h("input", { value: t.chuDe ?? "", placeholder: "ví dụ: mẹo dựng video ngắn cho người mới", "data-testid": "goi-chu-de", dataset: { mang: m }, title: "Chủ đề của bài đăng" });
        o.addEventListener("input", () => { t.chuDe = o.value; c.thayDoi(); });
        phan.push(oChu(`Chủ đề bài đăng (${MANG_TEN[m]})`, o, GIOI_HAN_GOI.chuDe));
      }
      if (can.has("nhomUrl")) {
        const o = h("input", { value: t.nhomUrl ?? "", placeholder: "Không bắt buộc — https://www.facebook.com/groups/…", "data-testid": "goi-nhom-url", dataset: { mang: m }, title: "Địa chỉ nhóm Facebook bạn đã tham gia và được phép đăng. Để trống: bot tự chọn trong các nhóm nick đã tham gia hợp chủ đề" });
        o.addEventListener("input", () => { t.nhomUrl = o.value; c.thayDoi(); });
        phan.push(oChu(`Địa chỉ nhóm Facebook (${MANG_TEN[m]}) — không bắt buộc`, o, GIOI_HAN_GOI.nhomUrl, "Không bắt buộc — để trống thì bot tự chọn trong các nhóm nick đã tham gia (đã vào, hợp từ khoá/chủ đề, không đăng lại cùng nhóm trong 3 ngày; không có nhóm hợp thì dừng, không đăng bừa). Có địa chỉ thì chỉ đăng vào nhóm đó (bạn phải là thành viên)."));
      }
      if (can.has("tenTrang")) {
        const o = h("input", { value: t.tenTrang ?? "", placeholder: "ví dụ: Cà Phê Mộc", "data-testid": "goi-ten-trang", dataset: { mang: m }, title: "Tên Trang (Page) Facebook mà nick đang quản lý — gõ đúng như hiện trên Facebook" });
        o.addEventListener("input", () => { t.tenTrang = o.value; c.thayDoi(); });
        phan.push(oChu(`Tên Trang Facebook (${MANG_TEN[m]})`, o, GIOI_HAN_GOI.tenTrang, "Trang do nick quản lý; dấu phải đúng, hoa/thường và khoảng trắng thừa không quan trọng. Bài đăng đứng TÊN TRANG."));
      }
      // Ghi đè lời văn theo mạng (tuỳ chọn): để trống = dùng lời văn chung ở trên.
      const gd = n.ghiDe[m];
      const gg = h("textarea", { rows: 2, "data-testid": "goi-gd-giong-dieu", class: "goi-ta", dataset: { mang: m }, placeholder: "Để trống = dùng giọng điệu chung ở trên" });
      gg.value = gd?.giongDieu ?? "";
      const gm = h("textarea", { rows: 2, "data-testid": "goi-gd-muc-tieu", class: "goi-ta", dataset: { mang: m }, placeholder: "Để trống = dùng mục tiêu chung ở trên" });
      gm.value = gd?.mucTieu ?? "";
      const dat = (): GhiDeNhap => (n.ghiDe[m] ??= { giongDieu: "", mucTieu: "", camKy: null });
      gg.addEventListener("input", () => { dat().giongDieu = gg.value; c.thayDoi(); });
      gm.addEventListener("input", () => { dat().mucTieu = gm.value; c.thayDoi(); });
      const rieng = h("input", { type: "checkbox", checked: !!gd?.camKy, "data-testid": "goi-gd-cam-ky-rieng", dataset: { mang: m } });
      const khoiCk = h("div", {}, gd?.camKy ? soanCamKy(gd.camKy, () => c.thayDoi(), "goi-gd-cam-ky-ds") : null);
      rieng.addEventListener("change", () => {
        const g = dat();
        g.camKy = rieng.checked ? [...n.loiVan.camKy] : null;
        clear(khoiCk);
        if (g.camKy) khoiCk.append(soanCamKy(g.camKy, () => c.thayDoi(), "goi-gd-cam-ky-ds"));
        c.thayDoi();
      });
      const coGhiDe = !!gd && (gd.giongDieu.trim() || gd.mucTieu.trim() || gd.camKy);
      phan.push(h("details", { class: "goi-gd", open: !!coGhiDe, "data-testid": "goi-gd", dataset: { mang: m } },
        h("summary", {}, `Lời văn riêng cho ${MANG_TEN[m]} (không bắt buộc)`),
        h("label", { class: "f" }, h("span", {}, "Giọng điệu riêng"), gg),
        h("label", { class: "f" }, h("span", {}, "Mục tiêu riêng"), gm),
        h("label", { class: "inline" }, rieng, "Dùng điều cấm riêng cho mạng này (thay cho danh sách chung)"), khoiCk));
      khoiMang.append(h("div", { class: "goi-lv-the", dataset: { mang: m }, "data-testid": "goi-lv-the" }, h("h4", {}, MANG_TEN[m]), ...(phan.length ? phan : [h("p", { class: "small muted" }, "Các kịch bản đã chọn của mạng này không cần từ khoá hay chủ đề.")])));
    }
    if (!khoiMang.children.length) khoiMang.append(h("p", { class: "small muted" }, "Chưa chọn mạng nào."));
  }
  veMang();
  return h("div", { class: "goi-lv", "data-testid": "goi-lv" },
    oChu("Giọng điệu", giong, GIOI_HAN_GOI.giongDieu, "Bạn đang nói với tư cách ai, theo kiểu nào. Để tự do — máy không khoá điều nào."),
    h("div", { class: "f" }, h("span", { class: "f-nhan" }, "Điều cấm (máy sẽ tránh những điều này khi viết)"), camKy),
    oChu("Mục tiêu", muc, GIOI_HAN_GOI.mucTieu),
    h("div", { class: "row between wrap goi-tu-khoa-dau" }, h("h3", { class: "goi-h3" }, "Từ khoá và chủ đề theo từng mạng"), nutAi), ketQuaAi,
    khoiMang);
}

/** Chấm màu + chữ trạng thái kịch bản (Mới / Đang dùng / Hoàn thiện) dùng chung kiểu với trang Kịch bản. */
const chipNhan = (nhan: string): HTMLElement => {
  const n = (nhan in TEN_NHAN ? nhan : "nhap") as Nhan;
  return h("span", { class: `kb-nhan kb-nhan-${n}`, "data-testid": "goi-nhan", dataset: { nhan: n }, "aria-label": `Trạng thái: ${TEN_NHAN[n]}` }, h("span", { class: "kb-cham", "aria-hidden": "true" }), TEN_NHAN[n]);
};

/** Một dòng tình trạng lịch (trang gói): nhãn tiếng Việt cho từng tinhTrang của cổng chạy thật. */
const TINH_TRANG: Record<GoiLichTinhTrang, { chu: string; loai: string; giai: string }> = {
  ok: { chu: "Sẵn sàng", loai: "ok", giai: "Bot trực tuyến, kịch bản sẵn sàng — tới giờ máy chủ sẽ chạy" },
  chua_co_bot: { chu: "Chưa chọn bot", loai: "warn", giai: "Lịch này chưa gắn bot nào — chọn bot rồi lưu" },
  bot_offline: { chu: "Bot ngoại tuyến", loai: "warn", giai: "Bot đang không trực tuyến; tới giờ mà vẫn ngoại tuyến thì lịch bị bỏ qua" },
  chua_duoc_phep: { chu: "Chưa sẵn sàng", loai: "warn", giai: "Mở kịch bản kiểm tra lại sơ đồ" },
  chua_chay_thu: { chu: "Kịch bản chưa sẵn sàng", loai: "warn", giai: "Mở kịch bản, bấm Lưu để tạo đủ các đoạn" },
  tam_dung: { chu: "Bot tạm dừng", loai: "err", giai: "Bot đang tạm dừng (ví dụ gặp CAPTCHA) — xử lý ở trang Bot rồi mới chạy tiếp" },
  het_han_muc: { chu: "Hết hạn mức", loai: "warn", giai: "Bot đã dùng hết hạn mức chạy trong 24 giờ gần nhất — lịch sẽ chạy lại khi còn hạn mức" },
  plugin_cu: { chu: "Plugin cũ", loai: "err", giai: "Plugin của bot quá cũ cho kịch bản này — cập nhật plugin" },
};
export const tagTinhTrang = (t: GoiLichTinhTrang): HTMLElement => {
  const x = TINH_TRANG[t] ?? { chu: t, loai: "", giai: "" };
  return h("span", { class: `tag ${x.loai}`, title: x.giai, "data-testid": "goi-tinh-trang", dataset: { tinhTrang: t } }, x.chu);
};

interface TuyChonLich { bots: GoiBotView[]; mang: Mang; hienBat: boolean; thucTe?: Map<string, GoiDungLich[]>; thayDoi: () => void }

const HIEN_BOT_TOI_DA = 100; // danh sách 1000+ bot: chỉ vẽ tối đa ngần này dòng (gõ tên để lọc), "Chọn tất cả" vẫn áp cho mọi bot
/** Ô chọn NHIỀU bot cho một kịch bản: tick từng bot (trạng thái trực tuyến / ngoại tuyến / tạm dừng, đã chạy mạng này), "Chọn tất cả bot phù hợp",
 *  "Bỏ chọn", lọc theo tên khi nhiều bot. 0 bot = lịch tạo sau. Bot ngoại tuyến vẫn chọn được (có ghi chú). */
function veChonBot(ln: LichNhap, o: TuyChonLich, doi: () => void): HTMLElement {
  const tenMang = MANG_TEN[o.mang];
  const dem = h("span", { class: "small muted", "data-testid": "goi-bot-dem", "aria-live": "polite" });
  const canh = h("p", { class: "small warn", hidden: true, "data-testid": "goi-bot-canh", role: "status" });
  const ds = h("ul", { class: "goi-bot-chon-ds", "data-testid": "goi-bot-chon-ds", role: "group", "aria-label": `Bot chạy kịch bản (${tenMang})` });
  const con = h("p", { class: "small muted", hidden: true, "data-testid": "goi-bot-con" });
  const tim = o.bots.length > 8 ? h("input", { type: "search", placeholder: "Tìm bot theo tên", maxlength: 80, "data-testid": "goi-bot-tim", "aria-label": "Tìm bot theo tên", class: "goi-bot-tim" }) : null;
  const thuTu = new Map(o.bots.map((b, i) => [b.id, i]));
  // Thứ tự bot = thứ tự trong danh sách (máy chủ sắp theo tên) → giờ lệch của từng bot xác định; mã lạ (bot đã gỡ) giữ ở cuối để bỏ tick được.
  const datChon = (chon: Set<string>): void => {
    const bietTruoc = ln.botIds.filter((id) => !thuTu.has(id) && chon.has(id));
    ln.botIds = [...o.bots.filter((b) => chon.has(b.id)).map((b) => b.id), ...bietTruoc].slice(0, TOI_DA_BOT_KB);
  };
  const capNhatDem = (): void => {
    dem.textContent = `Đã chọn ${ln.botIds.length}/${o.bots.length} bot${ln.botIds.length ? "" : " — chưa chọn bot: lịch sẽ tạo sau"}`;
  };
  const veDs = (): void => {
    clear(ds);
    const q = (tim?.value ?? "").trim().toLowerCase();
    const loc = o.bots.filter((b) => !q || b.name.toLowerCase().includes(q) || b.id.toLowerCase().includes(q));
    const hien = loc.slice(0, HIEN_BOT_TOI_DA);
    const chon = new Set(ln.botIds);
    for (const b of hien) {
      const cb = h("input", { type: "checkbox", checked: chon.has(b.id), "data-testid": "goi-bot-chon", dataset: { botId: b.id }, "aria-label": `Chọn bot ${b.name}` });
      cb.addEventListener("change", () => {
        const c = new Set(ln.botIds);
        if (cb.checked) {
          if (c.size >= TOI_DA_BOT_KB) { cb.checked = false; canh.hidden = false; canh.textContent = `Tối đa ${TOI_DA_BOT_KB} bot cho một kịch bản.`; return; }
          c.add(b.id);
        } else c.delete(b.id);
        canh.hidden = true;
        datChon(c); capNhatDem(); o.thayDoi(); doi();
      });
      const ghiChu = b.tamDung ? h("span", { class: "small err" }, " — đang tạm dừng ở mạng này, chọn được nhưng lịch bị bỏ qua tới khi xử lý")
        : !b.online ? h("span", { class: "small muted", "data-testid": "goi-bot-ngoai-tuyen" }, " — vẫn chọn được (lịch chạy khi bot trực tuyến)") : null;
      ds.append(h("li", { class: "goi-bot-chon-dong", dataset: { botId: b.id } }, h("label", { class: "goi-bot-chon-nhan", title: b.name },
        cb, h("span", { class: "goi-bot-ten", "data-testid": "goi-bot-ten" }, b.name), " ", trangThaiBot(b),
        b.daChayMang ? h("span", { class: "tag ok", "data-testid": "goi-bot-da-chay", title: `Bot này đã từng chạy kịch bản ${tenMang}` }, `đã chạy ${tenMang}`) : null, ghiChu)));
    }
    for (const id of ln.botIds.filter((x) => !thuTu.has(x))) {
      const cb = h("input", { type: "checkbox", checked: true, "data-testid": "goi-bot-chon", dataset: { botId: id }, "aria-label": `Bỏ chọn bot ${id}` });
      cb.addEventListener("change", () => { const c = new Set(ln.botIds); c.delete(id); datChon(c); capNhatDem(); o.thayDoi(); doi(); veDs(); });
      ds.append(h("li", { class: "goi-bot-chon-dong" }, h("label", { class: "goi-bot-chon-nhan" }, cb, h("span", { class: "goi-bot-ten" }, id), h("span", { class: "small warn" }, " — không còn trong danh sách bot của mạng này"))));
    }
    if (!o.bots.length && !ln.botIds.length) ds.append(h("li", { class: "small muted", "data-testid": "goi-bot-trong" }, `Chưa có bot cho ${tenMang} — lịch sẽ tạo sau khi bạn có bot.`));
    else if (q && !loc.length) ds.append(h("li", { class: "small muted" }, "Không có bot nào khớp tên này."));
    con.hidden = loc.length <= HIEN_BOT_TOI_DA;
    con.textContent = `Đang hiện ${HIEN_BOT_TOI_DA}/${loc.length} bot — gõ tên vào ô tìm để thấy bot khác. “Chọn tất cả bot phù hợp” áp cho mọi bot.`;
  };
  const tatCa = h("button", { type: "button", class: "mini", "data-testid": "goi-bot-chon-tat-ca", disabled: !o.bots.length,
    title: `Chọn mọi bot đã chạy ${tenMang} (chưa bot nào có dữ liệu thì chọn mọi bot); bỏ bot đang tạm dừng ở mạng này. Tối đa ${TOI_DA_BOT_KB} bot.` }, "Chọn tất cả bot phù hợp");
  tatCa.addEventListener("click", () => {
    const hop = botPhuHop(o.bots);
    datChon(new Set(hop.map((b) => b.id)));
    canh.hidden = hop.length <= TOI_DA_BOT_KB && hop.length > 0;
    canh.textContent = !hop.length ? "Không có bot phù hợp (mọi bot đang tạm dừng ở mạng này)." : `Có ${hop.length} bot phù hợp — chỉ chọn ${TOI_DA_BOT_KB} bot đầu (tối đa cho một kịch bản).`;
    capNhatDem(); veDs(); o.thayDoi(); doi();
  });
  const boChon = h("button", { type: "button", class: "mini", "data-testid": "goi-bot-bo-chon", title: "Bỏ chọn mọi bot (lịch sẽ tạo sau khi chọn bot)" }, "Bỏ chọn");
  boChon.addEventListener("click", () => { datChon(new Set()); canh.hidden = true; capNhatDem(); veDs(); o.thayDoi(); doi(); });
  let hen: number | undefined;
  tim?.addEventListener("input", () => { window.clearTimeout(hen); hen = window.setTimeout(veDs, 150); });
  capNhatDem();
  veDs();
  return h("div", { class: "f goi-bot-chon", "data-testid": "goi-bot-chon-khoi" },
    h("div", { class: "row between wrap goi-bot-chon-dau" }, h("span", { class: "f-nhan" }, "Bot chạy (chọn một hoặc nhiều)"), dem),
    h("div", { class: "row wrap goi-bot-chon-nut" }, tatCa, boChon, tim),
    ds, con, canh,
    h("p", { class: "small muted" }, `Mỗi bot có lịch riêng; giờ chạy các bot tự lệch nhau (cách nhau ít nhất ${CACH_BOT_TOI_THIEU} phút, rải đều trong khoảng lệch) để không nhiều nick cùng phút. Giới hạn mỗi ngày áp cho TỪNG bot.`));
}

/** Xem trước giờ của từng bot trong một khung (theo thứ tự đã chọn). */
function gioCacBot(gio: string, lech: string, ln: LichNhap, bots: GoiBotView[]): string {
  const n = ln.botIds.length;
  if (n < 2 || !/^([01]\d|2[0-3]):[0-5]\d$/.test(gio.trim())) return "";
  const l = /^\d+$/.test(lech.trim()) ? Math.min(LECH_TOI_DA, Number(lech.trim())) : 0;
  const ten = (id: string): string => { const t = Array.from(bots.find((b) => b.id === id)?.name ?? id); return t.length > 24 ? `${t.slice(0, 23).join("")}…` : t.join(""); };
  const ds = ln.botIds.map((id, i) => ({ id, ...gioTheoBot(gio.trim(), l, i, n) }));
  const xem = ds.length > 4 ? [...ds.slice(0, 3), null, ds[ds.length - 1]!] : ds;
  return `${n} bot: ${xem.map((x) => (x ? `${ten(x.id)} ${x.gio}` : "…")).join(", ")}${ds[0]!.lech ? ` (mỗi bot trễ thêm ngẫu nhiên 0–${ds[0]!.lech} phút)` : ""}`;
}
/** Thẻ tần suất của MỘT kịch bản: bot, giới hạn mỗi ngày, các khung giờ (giờ, thứ T2–CN, lệch phút, bật/tắt). */
function veLichKb(kb: KbGoi, ln: LichNhap, o: TuyChonLich): HTMLElement {
  const nutKhung = h("div", { class: "goi-khung-ds", "data-testid": "goi-khung-ds" });
  const moiNgay = h("input", { inputmode: "numeric", value: ln.moiNgay, autocomplete: "off", "data-testid": "goi-moi-ngay", title: `Số lượt tối đa mỗi 24 giờ (1–${GIOI_HAN_GOI.moiNgay}); nên bằng hoặc hơn số khung giờ mỗi ngày` });
  const canhMoi = h("p", { class: "small warn", hidden: true, "data-testid": "goi-moi-ngay-canh" });
  const kiemMoi = (): void => {
    const so = soNguyen(moiNgay.value);
    const hien = Number.isInteger(so) && so >= 1 && so < ln.khung.length;
    canhMoi.hidden = !hien;
    if (hien) canhMoi.textContent = `Giới hạn mỗi ngày (${so}) ít hơn số khung giờ (${ln.khung.length}) — hạn mức đếm trong 24 giờ trượt nên có khung sẽ bị bỏ qua.`;
  };
  moiNgay.addEventListener("input", () => { ln.moiNgay = moiNgay.value; kiemMoi(); o.thayDoi(); });
  const ve = (): void => {
    clear(nutKhung);
    ln.khung.forEach((k, i) => {
      const gio = h("input", { value: k.gio, inputmode: "numeric", placeholder: "HH:MM", autocomplete: "off", "data-testid": "goi-khung-gio", title: "Giờ chạy theo giờ Việt Nam, dạng HH:MM (00:00–23:59)", "aria-label": "Giờ chạy" });
      gio.addEventListener("input", () => { k.gio = gio.value; o.thayDoi(); });
      gio.addEventListener("blur", () => { if (/^\d:[0-5]\d$/.test(gio.value.trim())) { gio.value = `0${gio.value.trim()}`; k.gio = gio.value; o.thayDoi(); } });
      const thuBox = h("div", { class: "goi-thu", role: "group", "aria-label": "Các ngày trong tuần" });
      CA_TUAN.forEach((d) => {
        const cb = h("input", { type: "checkbox", checked: k.thu.includes(d), dataset: { thu: String(d) }, "data-testid": "goi-khung-thu", title: NGAY_DAY[d - 1] });
        cb.addEventListener("change", () => { k.thu = cb.checked ? [...new Set([...k.thu, d])].sort((a, b) => a - b) : k.thu.filter((x) => x !== d); o.thayDoi(); });
        thuBox.append(h("label", { class: "inline goi-thu-o", title: NGAY_DAY[d - 1] }, cb, NGAY[d - 1]));
      });
      const lech = h("input", { value: k.lech, inputmode: "numeric", autocomplete: "off", "data-testid": "goi-khung-lech", title: `Mỗi ngày trễ ngẫu nhiên 0 tới số phút này (0–${LECH_TOI_DA}); 0 = đúng giờ`, "aria-label": "Lệch ngẫu nhiên (phút)" });
      const xemGio = h("div", { class: "goi-khung-bot-gio small muted", "data-testid": "goi-khung-bot-gio" }, gioCacBot(k.gio, k.lech, ln, o.bots));
      const veGio = (): void => { xemGio.textContent = gioCacBot(k.gio, k.lech, ln, o.bots); };
      gio.addEventListener("input", veGio);
      lech.addEventListener("input", () => { k.lech = lech.value; o.thayDoi(); veGio(); });
      const thuc = o.thucTe?.get(k.id) ?? [];
      const bat = o.hienBat ? h("label", { class: "inline", title: "Bật = máy chủ sẽ chạy THẬT khung này đúng giờ" }, h("input", { type: "checkbox", checked: k.bat, "data-testid": "goi-khung-bat", onchange: (e: Event) => { k.bat = (e.target as HTMLInputElement).checked; o.thayDoi(); } }), "bật") : null;
      const xoa = h("button", { type: "button", class: "mini", "data-testid": "goi-khung-xoa", title: "Xoá khung giờ này", "aria-label": "Xoá khung giờ", onclick: () => { ln.khung.splice(i, 1); o.thayDoi(); ve(); kiemMoi(); } }, "Xoá");
      nutKhung.append(h("div", { class: "goi-khung", "data-testid": "goi-khung", dataset: { khungId: k.id } },
        h("label", { class: "goi-khung-o" }, h("span", { class: "small muted" }, "Giờ"), gio),
        h("div", { class: "goi-khung-o goi-khung-thu" }, h("span", { class: "small muted" }, "Các ngày"), thuBox),
        h("label", { class: "goi-khung-o" }, h("span", { class: "small muted" }, "Lệch (phút)"), lech),
        h("div", { class: "goi-khung-cuoi" }, bat, xoa),
        xemGio,
        ...thuc.slice(0, 5).map((t) => h("div", { class: "goi-khung-tt small", "data-testid": "goi-khung-tt", dataset: { botId: t.botId ?? "" } }, tagTinhTrang(t.tinhTrang),
          thuc.length > 1 ? h("span", { class: "goi-khung-tt-bot", "data-testid": "goi-khung-tt-bot" }, ` ${t.botTen ?? t.botId ?? ""}`) : null,
          t.gioHomNay ? h("span", { class: "muted", "data-testid": "goi-gio-hom-nay" }, ` hôm nay chạy lúc ${t.gioHomNay}`) : null)),
        thuc.length > 5 ? h("div", { class: "goi-khung-tt small muted", "data-testid": "goi-khung-tt-them" }, `… và ${thuc.length - 5} bot khác (xem ở trang Cài đặt → Lịch)`) : null));
    });
    const them = h("button", { type: "button", class: "mini", "data-testid": "goi-khung-them", disabled: ln.khung.length >= TOI_DA_KHUNG, title: `Thêm một khung giờ chạy (tối đa ${TOI_DA_KHUNG})`,
      onclick: () => { ln.khung.push({ id: maKhung(), gio: "12:00", thu: [...CA_TUAN], lech: "10", bat: false }); o.thayDoi(); ve(); kiemMoi(); } }, "+ Thêm khung giờ");
    nutKhung.append(h("div", { class: "row" }, them, h("span", { class: "small muted" }, `${ln.khung.length}/${TOI_DA_KHUNG} khung`)));
  };
  ve();
  kiemMoi();
  const chonBot = veChonBot(ln, o, () => { for (const el of nutKhung.querySelectorAll<HTMLElement>('[data-testid="goi-khung"]')) { const k = ln.khung.find((x) => x.id === el.dataset.khungId); const x = el.querySelector<HTMLElement>('[data-testid="goi-khung-bot-gio"]'); if (k && x) x.textContent = gioCacBot(k.gio, k.lech, ln, o.bots); } });
  return h("div", { class: "goi-lich-kb", "data-testid": "goi-lich-kb", dataset: { ma: kb.ma } },
    h("div", { class: "row between wrap" }, h("b", { class: "goi-lich-ten" }, kb.ten), h("span", { class: "tag" }, LOAI_TEN[kb.loai])),
    h("p", { class: "small muted" }, kb.moTa),
    chonBot,
    h("div", { class: "field-row" },
      h("label", { class: "f" }, h("span", {}, "Giới hạn mỗi ngày cho MỖI bot (lượt)"), moiNgay)),
    canhMoi, nutKhung);
}

/** Thẻ chọn MỘT mạng + các kịch bản của nó (trình hướng dẫn bước 2 và thẻ sửa ở trang gói). Đổi tick chỉ vẽ lại phần danh sách kịch bản (ô tick giữ nguyên). */
function theMangChon(m: GoiMangView, n: Nhap, o: { conBot: boolean; thayDoi: () => void }): HTMLElement {
  const cb = h("input", { type: "checkbox", checked: n.mang.includes(m.mang), "data-testid": "goi-mang", dataset: { mang: m.mang } });
  const kbHost = h("div", {});
  const the = h("div", { class: "card goi-mang-the", "data-testid": "goi-mang-the", dataset: { mang: m.mang } }, h("label", { class: "inline goi-mang-nhan" }, cb, h("b", {}, m.ten)));
  if (o.conBot) {
    the.append(m.bot.length
      ? h("div", {}, h("div", { class: "small muted" }, "Bot đang có:"), h("ul", { class: "goi-bot-ds", "data-testid": "goi-bot-ds" }, m.bot.map((b) => h("li", { dataset: { botId: b.id } }, b.name, " ", trangThaiBot(b)))))
      : h("p", { class: "small warn", "data-testid": "goi-chua-co-bot" }, "Chưa có bot cho mạng này — vẫn chọn được, lịch sẽ tạo sau khi bạn có bot."));
  }
  the.append(kbHost);
  const veKb = (): void => {
    clear(kbHost);
    const bat = n.mang.includes(m.mang);
    the.classList.toggle("on", bat);
    if (!bat) return;
    kbHost.append(h("div", { class: "goi-kb-ds" }, m.kichBan.map((k) => {
      const kc = h("input", { type: "checkbox", checked: n.kichBanBat.includes(k.ma), "data-testid": "goi-kb", dataset: { ma: k.ma } });
      const tdHost = h("div", {});
      const veTd = (): void => { clear(tdHost); if (k.coKemAnh && n.kichBanBat.includes(k.ma)) tdHost.append(oKemAnh(k, n, o.thayDoi)); if (k.ruiRoCao && n.kichBanBat.includes(k.ma)) tdHost.append(oTuDong(k, n, o.thayDoi)); };
      kc.addEventListener("change", () => {
        n.kichBanBat = kc.checked ? [...n.kichBanBat, k.ma] : n.kichBanBat.filter((x) => x !== k.ma);
        if (!kc.checked) { n.tuDuyet = (n.tuDuyet ?? []).filter((x) => x !== k.ma); n.kemAnh = (n.kemAnh ?? []).filter((x) => x !== k.ma); } // bỏ tick → lần sau tick lại về mặc định (Tự động BẬT nếu rủi ro cao)
        else batTuDongMacDinh(n, k);
        veTd();
        o.thayDoi();
      });
      veTd();
      return h("div", { class: "goi-kb-o" },
        h("label", { class: "goi-kb-dong" }, kc, h("span", { class: "goi-kb-noi" }, h("span", {}, h("b", {}, k.ten), " ", h("span", { class: "tag" }, LOAI_TEN[k.loai])), h("span", { class: "small muted" }, k.moTa))),
        tdHost);
    })));
  };
  cb.addEventListener("change", () => {
    if (cb.checked) { n.mang = MANG.filter((x) => x === m.mang || n.mang.includes(x)); for (const k of m.kichBan) if (k.macDinhBat && !n.kichBanBat.includes(k.ma)) { n.kichBanBat.push(k.ma); batTuDongMacDinh(n, k); } }
    else { n.mang = n.mang.filter((x) => x !== m.mang); n.kichBanBat = n.kichBanBat.filter((ma) => !m.kichBan.some((k) => k.ma === ma)); n.tuDuyet = (n.tuDuyet ?? []).filter((ma) => !m.kichBan.some((k) => k.ma === ma)); }
    veKb();
    o.thayDoi();
  });
  veKb();
  return the;
}

/** Lựa chọn "Bình luận kèm ảnh (từ kho ảnh sản phẩm)" của MỘT kịch bản bình luận / trả lời Facebook, X, Reddit. Mặc định TẮT; bật không cần hỏi
 *  (mỗi câu vẫn qua cổng duyệt như cũ, người duyệt thấy ảnh và bỏ ảnh được). */
function oKemAnh(k: GoiKichBanView, n: Nhap, thayDoi: () => void): HTMLElement {
  const cb = h("input", { type: "checkbox", checked: (n.kemAnh ?? []).includes(k.ma), "data-testid": "goi-kem-anh", dataset: { ma: k.ma }, "aria-label": `Bình luận kèm ảnh cho kịch bản ${k.ten}` });
  // (05/10/2026) bật kèm ảnh → ô "Ảnh dùng" (chọn NHIỀU ảnh / album trong Kho ảnh — bot lấy ngẫu nhiên); không chọn = ảnh sản phẩm như trước.
  const anhHost = h("div", { class: "goi-kem-anh-chon", "data-testid": "goi-anh-chon", dataset: { ma: k.ma } });
  const veAnh = (): void => {
    clear(anhHost);
    if (!cb.checked) return;
    anhHost.append(oAnhChon({ nhan: "Ảnh dùng (Kho ảnh)", moTa: "" }, n.anhChon?.[k.ma] ?? "", { testid: "goi-anh-chon-o", onDoi: (v) => {
      n.anhChon = { ...(n.anhChon ?? {}), [k.ma]: v };
      if (!v) delete n.anhChon[k.ma];
      veAnh();
      thayDoi();
    } }));
  };
  cb.addEventListener("change", () => {
    n.kemAnh = cb.checked ? [...new Set([...(n.kemAnh ?? []), k.ma])] : (n.kemAnh ?? []).filter((x) => x !== k.ma);
    veAnh();
    thayDoi();
  });
  veAnh();
  return h("div", {},
    h("label", { class: "goi-tu-duyet-dong", "data-testid": "goi-kem-anh-dong", dataset: { ma: k.ma }, title: "Mỗi câu bình luận / trả lời gửi kèm MỘT ảnh: ảnh bạn chọn trong Kho ảnh (bot lấy ngẫu nhiên), chưa chọn thì ảnh của sản phẩm (trang Sản phẩm). Không có ảnh → gửi chỉ chữ." },
      cb, h("span", { class: "goi-tu-duyet-chu" }, h("b", {}, "Bình luận kèm ảnh"), h("span", { class: "small muted" }, " — mỗi câu kèm một ảnh: chọn nhiều ảnh trong Kho ảnh (bot lấy ngẫu nhiên), chưa chọn thì dùng ảnh của sản phẩm; không có ảnh thì gửi chỉ chữ."))),
    anhHost);
}

/** Mặc định (09/10/2026): kịch bản có bước rủi ro cao được BẬT SẴN "Tự động (không cần duyệt)" lúc được chọn; người dùng vẫn gạt tắt tay. */
function batTuDongMacDinh(n: Nhap, k: GoiKichBanView): void {
  if (k.ruiRoCao) n.tuDuyet = [...new Set([...(n.tuDuyet ?? []), k.ma])];
}

/** Lựa chọn "Tự động (không cần duyệt)" của MỘT kịch bản (chỉ kịch bản có bước rủi ro cao). Mặc định BẬT lúc chọn kịch bản. Gạt tắt → không cần hỏi.
 *  Bật LẠI bằng tay → hộp xác nhận nói rõ "bot sẽ gửi/đăng mà không hỏi — bạn chịu trách nhiệm nội dung"; Huỷ/Esc → vẫn tắt. Bấm đúp → chỉ một hộp. */
function oTuDong(k: GoiKichBanView, n: Nhap, thayDoi: () => void): HTMLElement {
  const bat = (): boolean => (n.tuDuyet ?? []).includes(k.ma);
  const cb = h("input", { type: "checkbox", checked: bat(), "data-testid": "goi-tu-duyet", dataset: { ma: k.ma }, "aria-label": `${TU_DONG} cho kịch bản ${k.ten}` });
  const huy = h("span", { class: "tag warn goi-tu-duyet-bat", hidden: !bat(), "data-testid": "goi-tu-duyet-bat", dataset: { ma: k.ma } }, "⚡ Đang tự động");
  let dangHoi = false;
  const dat = (v: boolean): void => {
    n.tuDuyet = v ? [...new Set([...(n.tuDuyet ?? []), k.ma])] : (n.tuDuyet ?? []).filter((x) => x !== k.ma);
    cb.checked = v; huy.hidden = !v;
    thayDoi();
  };
  cb.addEventListener("change", () => void (async () => {
    if (!cb.checked) { dat(false); return; }
    cb.checked = false; // chỉ bật SAU khi người dùng xác nhận
    if (dangHoi) return;
    dangHoi = true;
    try {
      const ok = await confirmBox({ title: `Bật “${TU_DONG}”?`, text: `Kịch bản “${k.ten}”: khi chạy thật, ${CANH_BAO_TU_DONG}. Lịch chạy không người trực cũng sẽ gửi. AI gác cổng thấy nghi ngờ thì vẫn dừng hỏi. Bạn có thể tắt lại bất cứ lúc nào.`, okText: "Bật tự động", okTitle: "Bật: các bước gửi/đăng của kịch bản này không hỏi duyệt nữa", danger: true });
      if (ok) dat(true);
    } finally { dangHoi = false; }
  })());
  return h("label", { class: "goi-tu-duyet-dong", "data-testid": "goi-tu-duyet-dong", dataset: { ma: k.ma }, title: `Bật: chạy thật không dừng hỏi duyệt các bước gửi/đăng của kịch bản này — ${CANH_BAO_TU_DONG}` },
    cb, h("span", { class: "goi-tu-duyet-chu" }, h("b", {}, TU_DONG), " ", huy, h("span", { class: "small warn" }, ` — ${CANH_BAO_TU_DONG}.`)));
}

function trangThaiBot(b: GoiBotView): HTMLElement {
  if (b.tamDung) return h("span", { class: "tag err", title: `Bot đang tạm dừng: ${b.tamDung}` }, `tạm dừng: ${b.tamDung}`);
  return b.online ? h("span", { class: "tag ok" }, "trực tuyến") : h("span", { class: "tag", title: "Bot đang ngoại tuyến" }, "ngoại tuyến");
}

// =====================================================================================================
// Danh sách: gói có sẵn + gói của bạn
// =====================================================================================================
export async function renderGoiDs(root: HTMLElement): Promise<() => void> {
  const alive = gen("goi-seeding");
  root.append(h("h1", {}, "Gói seeding"));
  root.append(h("div", { class: "card goi-gioi-thieu" },
    h("p", {}, "Gói seeding là bộ kịch bản làm sẵn để quảng bá sản phẩm của bạn trên nhiều mạng xã hội: nuôi nick, bình luận theo từ khoá, đăng bài. Bạn chọn sản phẩm, chọn mạng muốn quảng bá, chỉnh lời văn và giờ chạy — máy tạo sẵn kịch bản và lịch (ở trạng thái TẮT)."),
    h("p", { class: "small muted" }, "Không có gì tự chạy: bạn phải bấm ▶ Chạy hoặc bật lịch, và mỗi câu đăng/bình luận vẫn cần người duyệt (trừ kịch bản bạn tự bật “Tự động (không cần duyệt)” — mặc định tắt).")));
  const nhap0 = docNhap();
  const nhapDo = nhap0 && (nhap0.sanPhamId || nhap0.mang.length || nhap0.buoc > 1) ? nhap0 : null; // bản nháp trống (vừa mở, chưa chọn gì) không phải "tạo dở"
  const bangNhapDo = h("div", { class: "info-box goi-nhap-do", hidden: !nhapDo, "data-testid": "goi-nhap-do" });
  if (nhapDo) {
    bangNhapDo.append(h("span", {}, `Bạn đang tạo dở một gói (đã tới bước ${nhapDo.buoc}/4${nhapDo.sanPhamTen ? `, sản phẩm “${nhapDo.sanPhamTen}”` : ""}). `),
      h("a", { class: "btn mini pri", href: `#/goi-seeding/moi?goi=${encodeURIComponent(nhapDo.goiMa)}`, "data-testid": "goi-nhap-do-tiep", title: "Mở lại trình hướng dẫn, giữ nguyên những gì đã nhập" }, "Tiếp tục"), " ",
      h("button", { type: "button", class: "mini", "data-testid": "goi-nhap-do-bo", title: "Xoá bản nháp đang dở", onclick: () => { xoaNhap(); bangNhapDo.hidden = true; } }, "Bỏ bản nháp"));
  }
  root.append(bangNhapDo);

  // ---- gói có sẵn ----
  const theGoi = h("div", { class: "goi-ds-co-san", "data-testid": "goi-ds-co-san" }, h("p", { class: "muted" }, "Đang tải gói…"));
  root.append(h("h2", {}, "Gói có sẵn"), theGoi);
  // ---- gói của bạn ----
  const ds = h("div", { "data-testid": "goi-dung-ds" });
  const them = h("button", { type: "button", hidden: true, "data-testid": "goi-xem-them", title: "Tải thêm các gói cũ hơn" }, "Xem thêm");
  const dai = h("div", { class: "warn-box", hidden: true, "data-testid": "goi-ds-ban-moi" });
  root.append(h("h2", {}, "Gói của bạn"), dai, h("div", { class: "card" }, ds, h("div", { class: "row" }, them)));

  try {
    const r = await api<{ goi: GoiView[] }>("GET", "/api/goi-seeding");
    if (!alive()) return () => {};
    clear(theGoi);
    if (!r.goi.length) theGoi.append(h("p", { class: "empty" }, "Chưa có gói nào."));
    for (const g of r.goi) {
      theGoi.append(h("div", { class: "card goi-the", "data-testid": "goi-the", dataset: { ma: g.ma } },
        h("div", { class: "row between wrap" }, h("h3", { class: "goi-the-ten" }, g.ten), h("span", { class: "tag", title: "Phiên bản nội dung của gói; tăng khi gói được cập nhật" }, `phiên bản ${g.phienBan}`)),
        h("p", { class: "wrap" }, g.moTa),
        h("div", { class: "row wrap goi-mang-tag" }, g.mang.map((m) => h("span", { class: "tag", title: `${m.kichBan.length} kịch bản` }, `${m.ten} · ${m.kichBan.length} kịch bản`))),
        h("div", { class: "row", style: "margin-top:8px" }, h("a", { class: "btn pri", href: `#/goi-seeding/moi?goi=${encodeURIComponent(g.ma)}`, "data-testid": "goi-dung-goi", title: "Dùng gói này: chọn sản phẩm, mạng, lời văn, tần suất" }, "Dùng gói"))));
    }
  } catch (e) {
    if (!alive()) return () => {};
    clear(theGoi);
    theGoi.append(h("div", { class: "err-box", "data-testid": "goi-loi-tai" }, `Không tải được danh sách gói: ${errMsg(e)}`), h("p", {}, h("button", { type: "button", title: "Tải lại trang để lấy lại danh sách gói", onclick: () => { location.reload(); } }, "Tải lại trang")));
  }

  let before: string | null = null;
  let soMoi = 0;
  const tai = async (): Promise<void> => {
    const r = await api<{ items: GoiDungTomTat[]; nextBefore: string | null }>("GET", `/api/goi-seeding/dung${buildQuery({ limit: 50, before })}`);
    if (!alive()) return;
    if (!before && !r.items.length) ds.append(h("p", { class: "empty", "data-testid": "goi-dung-trong" }, "Bạn chưa dùng gói nào — bấm “Dùng gói” ở trên để bắt đầu."));
    for (const g of r.items) {
      if (g.coBanMoi) soMoi++;
      ds.append(h("a", { class: "kb-dong goi-dong", href: `#/goi-seeding/${encodeURIComponent(g.id)}`, "data-testid": "goi-dung-dong", dataset: { id: g.id } },
        h("span", { class: "kb-dong-ten", "data-testid": "goi-dong-ten" }, `${g.goiTen} · ${g.sanPham.ten}`),
        g.mang.map((m) => h("span", { class: "tag" }, MANG_TEN[m] ?? m)),
        g.coBanMoi ? h("span", { class: "tag warn", "data-testid": "goi-dong-moi", title: "Gói đã có phiên bản mới hơn — mở gói rồi bấm Áp dụng" }, "có bản mới") : null,
        h("span", { class: "kb-dong-phu small muted", "data-testid": "goi-dong-so" }, `${g.soKichBan} kịch bản · bật ${g.soLichBat}/${g.soLich} lịch · sửa ${fmtTime(g.suaLuc)}`),
        h("span", { class: "btn mini", title: "Mở gói này" }, "Mở")));
    }
    before = r.nextBefore;
    them.hidden = !before;
    dai.hidden = soMoi === 0;
    if (soMoi) dai.textContent = `Có ${soMoi} gói của bạn đã có phiên bản mới hơn (xem dòng “có bản mới” bên dưới). Mở gói rồi bấm “Áp dụng bản mới”.`;
  };
  them.addEventListener("click", () => {
    if (them.disabled) return;
    them.disabled = true;
    void tai().catch((e) => toast(errMsg(e), "err")).finally(() => { them.disabled = false; });
  });
  await tai().catch((e) => { if (alive()) ds.append(h("div", { class: "err-box", "data-testid": "goi-loi-tai-dung" }, `Không tải được danh sách gói của bạn: ${errMsg(e)}`)); });
  return () => {};
}

// =====================================================================================================
// Trình hướng dẫn 4 bước (#/goi-seeding/moi)
// =====================================================================================================
interface SpDong { id: string; ten: string; tomTatNgan?: string; soTep?: number; soAnh?: number }

async function renderWizard(root: HTMLElement, query: URLSearchParams): Promise<() => void> {
  const alive = gen("goi-seeding");
  const r = await api<{ goi: GoiView[] }>("GET", "/api/goi-seeding");
  if (!alive()) return () => {};
  let n = docNhap();
  const goiQuery = query.get("goi");
  const view0 = r.goi.find((g) => g.ma === (n?.goiMa ?? goiQuery ?? "")) ?? r.goi.find((g) => g.ma === goiQuery) ?? r.goi[0];
  if (!view0) { root.append(h("h1", {}, "Dùng gói"), h("div", { class: "err-box", "data-testid": "goi-khong-co" }, "Chưa có gói nào để dùng.")); return () => {}; }
  const view: GoiView = view0;
  if (!n || n.goiMa !== view.ma) { n = nhapMoi(view); luuNhap(n); }
  const nn: Nhap = n; // alias không-null cho closure
  const goi = goiDefTuView(view);
  const luu = (): void => luuNhap(nn);
  let dangTao = false;

  root.append(h("h1", {}, `Dùng gói: ${view.ten}`));
  const thanh = h("ol", { class: "goi-buoc", "data-testid": "goi-buoc-ds" });
  const sanKhau = h("div", { class: "card goi-san-khau", "data-testid": "goi-san-khau" });
  const hopLoiEl = hopLoi("goi-loi");
  const lui = h("button", { type: "button", "data-testid": "goi-lui", title: "Về bước trước (giữ nguyên những gì đã nhập)" }, "Quay lại");
  const tiep = h("button", { type: "button", class: "pri", "data-testid": "goi-tiep", title: "Kiểm bước này rồi sang bước sau" }, "Tiếp tục");
  const tao = h("button", { type: "button", class: "pri", "data-testid": "goi-tao", title: "Tạo các kịch bản và lịch (TẮT) theo những gì bạn đã chọn" }, "Tạo gói");
  const batDau = h("button", { type: "button", class: "mini", "data-testid": "goi-bat-dau-lai", title: "Xoá những gì đã nhập và làm lại từ bước 1",
    onclick: () => void (async () => { if (dangTao) return; if (!(await confirmBox({ title: "Bắt đầu lại?", text: "Mọi thứ bạn đã nhập trong trình hướng dẫn này sẽ bị xoá.", okText: "Bắt đầu lại", danger: true }))) return; xoaNhap(); location.reload(); })() }, "Bắt đầu lại");
  root.append(thanh, sanKhau, hopLoiEl, h("div", { class: "row between goi-dieu-huong" }, h("div", { class: "row" }, lui, batDau), h("div", { class: "row" }, tiep, tao)));

  const TEN_BUOC = ["Sản phẩm", "Mạng xã hội", "Lời văn", "Tần suất"];
  function veThanh(): void {
    clear(thanh);
    TEN_BUOC.forEach((t, i) => {
      const b = i + 1;
      const on = b === nn.buoc;
      const lamDuoc = b < nn.buoc;
      thanh.append(h("li", { class: `goi-buoc-o${on ? " on" : ""}${lamDuoc ? " xong" : ""}`, "data-testid": "goi-buoc-tab", dataset: { buoc: String(b), on: on ? "1" : "0" }, "aria-current": on ? "step" : undefined },
        lamDuoc ? h("button", { type: "button", class: "link", title: `Về bước ${b}`, onclick: () => { if (dangTao) return; dat(b); } }, `${b}. ${t}`) : h("span", {}, `${b}. ${t}`)));
    });
  }
  function dat(b: number): void { nn.buoc = Math.max(1, Math.min(4, b)); luu(); hienLoi(hopLoiEl, []); ve(); window.scrollTo(0, 0); }

  let tenSp = nn.sanPhamTen;
  function ve(): void {
    veThanh();
    clear(sanKhau);
    lui.hidden = nn.buoc === 1;
    tiep.hidden = nn.buoc === 4;
    tao.hidden = nn.buoc !== 4;
    if (nn.buoc === 1) veSanPham();
    else if (nn.buoc === 2) veMangBuoc();
    else if (nn.buoc === 3) sanKhau.append(h("h3", {}, "Bước 3 — Lời văn"), h("p", { class: "small muted" }, "Máy viết bình luận/bài theo những gì bạn ghi ở đây. Bạn tự do ghi điều bạn muốn và điều không muốn — máy không khoá điều nào."),
      veLoiVan({ n: nn, goi, view: view, thayDoi: luu, veLai: ve, tenSp: () => tenSp }));
    else veTanSuat();
  }

  // ---- bước 1: sản phẩm ----
  function veSanPham(): void {
    sanKhau.append(h("h3", {}, "Bước 1 — Chọn sản phẩm bạn muốn quảng bá"));
    const chon = h("div", { class: "info-box", "data-testid": "goi-sp-chon", hidden: !nn.sanPhamId }, nn.sanPhamId ? `Đã chọn: ${nn.sanPhamTen || nn.sanPhamId}` : "");
    const tim = h("input", { type: "search", placeholder: "Tìm theo tên sản phẩm", "data-testid": "goi-sp-tim", maxlength: 80 });
    const dsEl = h("div", { class: "goi-sp-ds", "data-testid": "goi-sp-ds", role: "radiogroup", "aria-label": "Sản phẩm" });
    const them = h("button", { type: "button", hidden: true, "data-testid": "goi-sp-them", title: "Tải thêm sản phẩm" }, "Xem thêm");
    sanKhau.append(chon, h("div", { class: "row between wrap" }, tim, h("a", { class: "btn mini", href: "#/san-pham/moi", "data-testid": "goi-sp-moi", title: "Thêm một sản phẩm mới ở trang Sản phẩm; dữ liệu đang nhập ở đây vẫn được giữ" }, "＋ Thêm sản phẩm mới")), dsEl, h("div", { class: "row" }, them));
    let before: string | null = null;
    let hen: number | undefined;
    const tai = async (): Promise<void> => {
      const r = await api<{ items: SpDong[]; nextBefore: string | null }>("GET", `/api/san-pham${buildQuery({ limit: 30, before, q: tim.value.trim() || null })}`);
      if (!alive()) return;
      if (!before && !r.items.length) {
        dsEl.append(tim.value.trim()
          ? h("p", { class: "empty", "data-testid": "goi-sp-trong" }, "Không có sản phẩm nào khớp tên này.")
          : h("div", { class: "empty", "data-testid": "goi-sp-trong" }, h("p", {}, "Bạn chưa có sản phẩm nào trong Thư viện."), h("p", {}, h("a", { class: "btn pri", href: "#/san-pham/moi", "data-testid": "goi-sp-trong-lien-ket" }, "Thêm sản phẩm đầu tiên")), h("p", { class: "small muted" }, "Thêm xong quay lại trang này — những gì bạn đã nhập vẫn còn.")));
      }
      for (const s of r.items) {
        const rd = h("input", { type: "radio", name: "goi-sp", checked: nn.sanPhamId === s.id, value: s.id, "data-testid": "goi-sp-radio" });
        rd.addEventListener("change", () => {
          if (!rd.checked) return;
          const tenCu = nn.sanPhamTen;
          nn.sanPhamId = s.id; nn.sanPhamTen = s.ten; tenSp = s.ten;
          if (!nn.loiVanSua) nn.loiVan = loiVanMacDinh(s.ten);
          else if (tenCu && tenCu !== s.ten) {
            // Lời văn đã sửa tay vẫn nhắc sản phẩm cũ → thay tên (giọng điệu, mục tiêu, cấm kỵ, lời văn riêng từng mạng); nếu không bot vẫn viết quảng cáo sản phẩm cũ.
            nn.loiVan = doiTenSanPhamTrongLoiVan(nn.loiVan, tenCu, s.ten);
            for (const g of Object.values(nn.ghiDe)) {
              if (!g) continue;
              const d = doiTenSanPhamTrongLoiVan({ giongDieu: g.giongDieu, camKy: g.camKy ?? [], mucTieu: g.mucTieu }, tenCu, s.ten);
              g.giongDieu = d.giongDieu; g.mucTieu = d.mucTieu; if (g.camKy) g.camKy = d.camKy;
            }
            toast(`Đã đổi tên “${tenCu}” thành “${s.ten}” trong lời văn. Kiểm lại lời văn, từ khoá và chủ đề ở các bước sau — nếu còn nhắc sản phẩm cũ bot vẫn viết về sản phẩm cũ.`, "warn");
          }
          chon.hidden = false; chon.textContent = `Đã chọn: ${s.ten}`;
          hienLoi(hopLoiEl, []);
          luu();
        });
        dsEl.append(h("label", { class: `goi-sp-dong${nn.sanPhamId === s.id ? " on" : ""}`, "data-testid": "goi-sp-dong", dataset: { id: s.id } }, rd,
          h("span", { class: "goi-sp-ten", "data-testid": "goi-sp-ten" }, s.ten), s.tomTatNgan ? h("span", { class: "small muted goi-sp-tt" }, s.tomTatNgan) : null));
      }
      before = r.nextBefore;
      them.hidden = !before;
    };
    const taiLai = (): void => { before = null; clear(dsEl); void tai().catch((e) => dsEl.append(h("div", { class: "err-box" }, `Không tải được danh sách sản phẩm: ${errMsg(e)}`))); };
    tim.addEventListener("input", () => { window.clearTimeout(hen); hen = window.setTimeout(taiLai, 250); });
    them.addEventListener("click", () => { if (them.disabled) return; them.disabled = true; void tai().catch((e) => toast(errMsg(e), "err")).finally(() => { them.disabled = false; }); });
    taiLai();
  }

  // ---- bước 2: mạng + kịch bản ----
  function veMangBuoc(): void {
    sanKhau.append(h("h3", {}, "Bước 2 — Chọn mạng muốn quảng bá"), h("p", { class: "small muted" }, "Không cần quảng bá cả 5 mạng. Mạng chưa có bot vẫn chọn được — lịch của mạng đó sẽ tạo sau khi bạn có bot."));
    for (const m of view.mang) sanKhau.append(theMangChon(m, nn, { conBot: true, thayDoi: () => { hienLoi(hopLoiEl, []); luu(); } }));
  }
  // ---- bước 4: tần suất ----
  function veTanSuat(): void {
    khoiTaoLich(nn, goi, view);
    luu();
    sanKhau.append(h("h3", {}, "Bước 4 — Tần suất chạy"),
      h("p", { class: "small muted" }, "Chọn một hoặc nhiều bot, giờ, các ngày trong tuần và độ lệch ngẫu nhiên cho từng kịch bản. Mỗi bot có lịch riêng, giờ các bot tự lệch nhau. Lịch được tạo ở trạng thái TẮT — bạn bật ở trang của gói khi muốn máy tự chạy."),
      h("div", { class: "warn-box", "data-testid": "goi-canh-bao-duyet" }, CANH_BAO_DUYET));
    const bat = kbDangBat(nn, goi);
    const tuDong = bat.filter((k) => (nn.tuDuyet ?? []).includes(k.ma));
    if (tuDong.length) sanKhau.append(h("div", { class: "warn-box", "data-testid": "goi-canh-bao-tu-dong" }, `${TU_DONG}: ${tuDong.map((k) => k.ten).join(", ")} — ${CANH_BAO_TU_DONG}.`));
    for (const kb of bat) {
      const ln = nn.lich[kb.ma]!;
      sanKhau.append(h("div", { class: "card goi-the-lich" }, veLichKb(kb, ln, { bots: botCuaMang(view, kb.mang), mang: kb.mang, hienBat: false, thayDoi: () => { hienLoi(hopLoiEl, []); luu(); } })));
    }
    if (!bat.length) sanKhau.append(h("p", { class: "empty" }, "Chưa có kịch bản nào được chọn — quay lại bước 2."));
  }

  lui.addEventListener("click", () => { if (dangTao) return; dat(nn.buoc - 1); });
  tiep.addEventListener("click", () => {
    if (dangTao) return;
    const loi = loiBuoc(nn, goi, nn.buoc);
    if (loi.length) { hienLoi(hopLoiEl, loi, `Chưa sang bước sau được (${loi.length} chỗ cần sửa):`); hopLoiEl.scrollIntoView({ block: "nearest" }); return; }
    dat(nn.buoc + 1);
  });
  tao.addEventListener("click", () => void (async () => {
    if (dangTao) return;
    // Kiểm lại từ bước 1: nếu còn lỗi ở bước trước thì đưa người dùng về đúng bước đó.
    for (const b of [1, 2, 3, 4]) {
      const loi = loiBuoc(nn, goi, b);
      if (loi.length) { if (b !== nn.buoc) dat(b); hienLoi(hopLoiEl, loi, `Chưa tạo được — bước ${b} còn ${loi.length} chỗ cần sửa:`); return; }
    }
    dangTao = true;
    const chu = tao.textContent;
    tao.disabled = true; tiep.disabled = true; lui.disabled = true; batDau.disabled = true;
    tao.textContent = "Đang tạo…";
    hienLoi(hopLoiEl, []);
    try {
      const ct = await api<GoiDungChiTiet>("POST", `/api/goi-seeding/${encodeURIComponent(nn.goiMa)}/dung`, { cauHinh: taoCauHinh(nn, goi, true), yeuCauId: nn.yeuCauId });
      xoaNhap();
      toast(`Đã tạo gói “${ct.goiTen}” cho sản phẩm “${ct.sanPham.ten}”`);
      location.hash = `/goi-seeding/${encodeURIComponent(ct.id)}`;
    } catch (e) {
      const l = loiTuMayChu(e);
      const mang = e instanceof ApiError && e.code === "network";
      hienLoi(hopLoiEl, l, mang ? "Chưa tạo được — dữ liệu bạn nhập vẫn được giữ, bấm “Tạo gói” lại khi có mạng:" : "Chưa tạo được — dữ liệu bạn nhập vẫn được giữ:");
    } finally {
      dangTao = false;
      tao.disabled = false; tiep.disabled = false; lui.disabled = false; batDau.disabled = false;
      tao.textContent = chu;
    }
  })());

  ve();
  return () => {};
}

// =====================================================================================================
// Trang một gói đã dùng (#/goi-seeding/:id) — id "moi" = trình hướng dẫn
// =====================================================================================================
/** Bản nháp sửa được dựng từ cấu hình đã lưu của gói (dùng lại các khối của trình hướng dẫn). */
function nhapTuChiTiet(ct: GoiDungChiTiet, goi: GoiDef, view: GoiView): Nhap {
  const c = ct.cauHinh;
  const bat = (c.kichBanBat ?? goi.kichBan.filter((k) => k.macDinhBat && c.mang.includes(k.mang)).map((k) => k.ma)).filter((ma) => kbCuaGoi(goi, ma));
  const n: Nhap = {
    v: 1, goiMa: ct.goiMa, yeuCauId: "", buoc: 4, sanPhamId: c.sanPhamId, sanPhamTen: ct.sanPham.ten,
    mang: MANG.filter((m) => c.mang.includes(m)), kichBanBat: [...bat],
    loiVan: { giongDieu: c.loiVan.giongDieu, camKy: [...c.loiVan.camKy], mucTieu: c.loiVan.mucTieu },
    // Lời văn còn y bản mặc định của sản phẩm đang dùng → CHƯA sửa tay: đổi sản phẩm phải tạo lại lời văn theo sản phẩm mới (lỗi 12/10/2026: luôn "đã sửa" nên lời văn giữ tên sản phẩm cũ).
    loiVanSua: !loiVanLaMacDinh(c.loiVan, ct.sanPham.ten),
    ghiDe: {}, thamSo: {}, lich: {},
    tuDuyet: Object.entries(c.tuDuyet ?? {}).filter(([ma, v]) => v === true && bat.includes(ma)).map(([ma]) => ma),
    kemAnh: Object.entries(c.kemAnh ?? {}).filter(([ma, v]) => v === true && bat.includes(ma)).map(([ma]) => ma),
    anhChon: Object.fromEntries(Object.entries(c.anhChon ?? {}).filter(([ma, v]) => typeof v === "string" && v && bat.includes(ma))),
  };
  for (const m of MANG) {
    const g = c.loiVanMang?.[m];
    if (g) n.ghiDe[m] = { giongDieu: g.giongDieu ?? "", mucTieu: g.mucTieu ?? "", camKy: g.camKy ? [...g.camKy] : null };
    const t = c.thamSo[m];
    if (t) n.thamSo[m] = { ...t };
  }
  for (const [ma, l] of Object.entries(c.lich ?? {})) {
    n.lich[ma] = { botIds: botIdsCuaLich(l), moiNgay: l.moiNgay === undefined ? String(kbCuaGoi(goi, ma)?.moiNgay ?? "") : String(l.moiNgay), khung: l.khung.map((k) => ({ id: k.id, gio: k.gio, thu: [...k.thu], lech: String(k.lech), bat: k.bat })) };
  }
  khoiTaoLich(n, goi, view);
  return n;
}

export async function renderGoiDung(root: HTMLElement, params: Record<string, string>, query: URLSearchParams): Promise<() => void> {
  if (params.id === "moi") return renderWizard(root, query);
  const alive = gen("goi-seeding");
  const id = params.id ?? "";
  const [rv, ct0] = await Promise.all([api<{ goi: GoiView[] }>("GET", "/api/goi-seeding"), api<GoiDungChiTiet>("GET", `/api/goi-seeding/dung/${encodeURIComponent(id)}`)]);
  if (!alive()) return () => {};
  let ct = ct0;
  const view = rv.goi.find((g) => g.ma === ct.goiMa);
  if (!view) { root.append(h("h1", {}, "Gói seeding"), h("div", { class: "err-box", "data-testid": "goi-khong-co" }, `Gói “${ct.goiMa}” không còn trong danh sách gói của máy chủ.`)); return () => {}; }
  const goi = goiDefTuView(view);

  const ve = (): void => {
    clear(root);
    root.append(h("div", { class: "row between wrap" }, h("h1", { "data-testid": "goi-ten" }, `${ct.goiTen} · ${ct.sanPham.ten}`), h("a", { href: "#/goi-seeding", class: "btn mini", title: "Về danh sách gói" }, "← Danh sách gói")));
    root.append(h("div", { class: "row wrap goi-tom-tat", "data-testid": "goi-chi-tiet" },
      ct.mang.map((m) => h("span", { class: "tag", "data-testid": "goi-mang-tag" }, MANG_TEN[m] ?? m)),
      h("span", { class: "small muted" }, `phiên bản gói ${ct.goiPhienBan} · bản của bạn ${ct.phienBan} · tạo ${fmtTime(ct.taoLuc)} · sửa ${fmtTime(ct.suaLuc)}`)));

    // ---- dải "có bản mới" ----
    if (ct.coBanMoi) {
      const ap = h("button", { type: "button", class: "pri", "data-testid": "goi-ap-dung", title: "Dựng lại các kịch bản CHƯA sửa tay theo bản mới; kịch bản đã sửa tay và lịch của bạn giữ nguyên" }, "Áp dụng bản mới");
      ap.addEventListener("click", () => void (async () => {
        if (ap.disabled) return;
        ap.disabled = true; ap.textContent = "Đang áp dụng…";
        try {
          const r = await api<GoiDungChiTiet>("POST", `/api/goi-seeding/dung/${encodeURIComponent(ct.id)}/ap-dung-ban-moi`, {});
          ct = r;
          toast(r.boQua?.length ? `Đã áp dụng bản mới; ${r.boQua.length} kịch bản đã sửa tay được giữ nguyên` : "Đã áp dụng bản mới");
          ve();
        } catch (e) { toast(errMsg(e), "err"); ap.disabled = false; ap.textContent = "Áp dụng bản mới"; }
      })());
      root.append(h("div", { class: "warn-box goi-ban-moi", "data-testid": "goi-ban-moi" }, h("span", { "data-testid": "goi-ban-moi-chu" }, `Gói có bản mới (phiên bản ${ct.goiPhienBan} → ${ct.goiPhienBanMoiNhat}). Kịch bản bạn đã sửa tay sẽ được giữ nguyên; lịch của bạn không đổi. `), ap));
    }
    if (ct.boQua?.length) root.append(h("div", { class: "info-box", "data-testid": "goi-bo-qua" }, h("b", {}, "Không áp dụng cho các kịch bản đã sửa tay:"), h("ul", {}, ct.boQua.map((b) => h("li", {}, `${b.ma}: ${b.lyDo}`)))));
    // ---- cảnh báo ----
    root.append(h("div", { class: "warn-box", "data-testid": "goi-canh-bao-duyet" }, CANH_BAO_DUYET));
    if (ct.canhBao.length) root.append(h("div", { class: "warn-box", "data-testid": "goi-canh-bao" }, h("ul", {}, ct.canhBao.map((c) => h("li", {}, c)))));

    // ---- bảng kịch bản ----
    const lichTheoKb = new Map<string, GoiDungLich[]>();
    for (const l of ct.lich) lichTheoKb.set(l.maKb, [...(lichTheoKb.get(l.maKb) ?? []), l]);
    const hang = ct.kichBan.map((k) => {
      const ls = lichTheoKb.get(k.ma) ?? [];
      return h("tr", { "data-testid": "goi-kb-dong", dataset: { ma: k.ma } },
        h("td", { class: "name" }, h("a", { href: `#/kich-ban/${encodeURIComponent(k.kichBanId)}`, "data-testid": "goi-kb-link", title: "Mở kịch bản này để xem sơ đồ, chạy, sửa" }, k.ten),
          (k.canhBao ?? []).map((c) => h("div", { class: "small warn wrap", "data-testid": "goi-kb-canh-bao" }, c))),
        h("td", {}, MANG_TEN[k.nenTang as Mang] ?? k.nenTang),
        h("td", { class: "nowrap" }, chipNhan(k.nhan), k.daSua ? h("span", { class: "tag", "data-testid": "goi-da-sua", title: "Bạn đã sửa tay kịch bản này — khi gói có bản mới nó được giữ nguyên" }, "đã sửa tay") : null),
        h("td", { class: "wrap", "data-testid": "goi-san-sang" }, k.sanSang.chayThat ? h("span", { class: "tag ok" }, "sẵn sàng chạy") : h("span", { class: "small muted" }, k.sanSang.lyDo ?? "chưa sẵn sàng chạy thật")),
        h("td", { class: "nowrap tabular" }, `${ls.filter((l) => l.enabled).length}/${ls.length} bật`));
    });
    root.append(h("div", { class: "card" }, h("h3", {}, "Kịch bản của gói"),
      hang.length ? h("div", { class: "tbl" }, h("table", {}, h("thead", {}, h("tr", {}, ["Kịch bản", "Mạng", "Trạng thái", "Sẵn sàng", "Lịch"].map((x) => h("th", {}, x)))), h("tbody", {}, hang))) : h("p", { class: "empty" }, "Gói chưa có kịch bản nào.")));

    // ---- tần suất chạy ----
    const nTs = nhapTuChiTiet(ct, goi, view);
    const thuc = new Map<string, GoiDungLich[]>();
    for (const l of ct.lich) thuc.set(`${l.maKb}/${l.khungId}`, [...(thuc.get(`${l.maKb}/${l.khungId}`) ?? []), l]);
    const loiTs = hopLoi("goi-ts-loi");
    const luuTs = h("button", { type: "button", class: "pri", "data-testid": "goi-luu-tan-suat", title: "Lưu giờ, ngày, độ lệch, bot, bật/tắt; lịch khớp theo khung giờ nên lịch sử chạy được giữ" }, "Lưu tần suất");
    const theTs = h("div", { class: "card", "data-testid": "goi-tan-suat" }, h("h3", {}, "Tần suất chạy"),
      h("p", { class: "small muted" }, "Sửa giờ, các ngày trong tuần, độ lệch ngẫu nhiên, các bot rồi bật lịch. Thêm bot = thêm lịch cho bot đó; bỏ bot = chỉ xoá lịch của bot đó. Lịch bật là tới giờ máy chủ chạy THẬT."));
    for (const kb of kbDangBat(nTs, goi)) {
      const lk = nTs.lich[kb.ma]!;
      theTs.append(h("div", { class: "goi-the-lich" }, veLichKb(kb, lk, { bots: botCuaMang(view, kb.mang), mang: kb.mang, hienBat: true, thucTe: new Map([...thuc].filter(([k]) => k.startsWith(`${kb.ma}/`)).map(([k, v]) => [k.slice(kb.ma.length + 1), v])), thayDoi: () => hienLoi(loiTs, []) })));
    }
    theTs.append(loiTs, h("div", { class: "row end" }, luuTs));
    luuTs.addEventListener("click", () => void luuCauHinh(luuTs, loiTs, () => taoCauHinh(nTs, goi, true), "Đã lưu tần suất"));
    root.append(theTs);

    // ---- lời văn / từ khoá / mạng ----
    const nLv = nhapTuChiTiet(ct, goi, view);
    const loiLv = hopLoi("goi-lv-loi");
    const luuLv = h("button", { type: "button", class: "pri", "data-testid": "goi-luu-loi-van", title: "Lưu lời văn, từ khoá, mạng; các kịch bản được dựng lại theo lời văn mới" }, "Lưu lời văn và mạng");
    const khoiMangSua = h("div", { class: "goi-mang-sua", "data-testid": "goi-mang-sua" });
    const khoiLv = h("div", {});
    const veKhoiLv = (): void => {
      clear(khoiLv);
      khoiLv.append(veLoiVan({ n: nLv, goi, view, thayDoi: () => hienLoi(loiLv, []), veLai: veKhoiLv, tenSp: () => ct.sanPham.ten }));
    };
    for (const m of view.mang) khoiMangSua.append(theMangChon(m, nLv, { conBot: false, thayDoi: () => { hienLoi(loiLv, []); veKhoiLv(); } }));
    veKhoiLv();
    luuLv.addEventListener("click", () => void luuCauHinh(luuLv, loiLv, () => {
      khoiTaoLich(nLv, goi, view);
      return taoCauHinh(nLv, goi, true);
    }, "Đã lưu — các kịch bản được dựng lại, lần chạy sau dùng lời văn mới"));
    root.append(h("div", { class: "card", "data-testid": "goi-loi-van-the" }, h("h3", {}, "Lời văn, từ khoá và mạng"),
      h("p", { class: "small muted" }, "Sau khi lưu, các kịch bản được dựng lại theo lời văn mới (lần chạy sau dùng bản mới). Mạng bạn bỏ đi: kịch bản vẫn còn ở trang Kịch bản nhưng ra khỏi gói và lịch của nó bị xoá."),
      h("h4", {}, "Mạng muốn quảng bá"), khoiMangSua, khoiLv, loiLv, h("div", { class: "row end" }, luuLv)));

    // ---- xoá gói ----
    const xoa = h("button", { type: "button", class: "danger", "data-testid": "goi-xoa", title: "Xoá gói này và các lịch của nó; các kịch bản vẫn giữ nguyên" }, "Xoá gói");
    xoa.addEventListener("click", () => void (async () => {
      if (xoa.disabled) return;
      const ok = await confirmBox({ title: "Xoá gói này?", text: "Các lịch của gói sẽ bị xoá. Các kịch bản đã tạo vẫn giữ nguyên ở trang Kịch bản.", okText: "Xoá gói", danger: true });
      if (!ok) return;
      xoa.disabled = true;
      try { await api("DELETE", `/api/goi-seeding/dung/${encodeURIComponent(ct.id)}`); toast("Đã xoá gói"); location.hash = "/goi-seeding"; }
      catch (e) { toast(errMsg(e), "err"); xoa.disabled = false; }
    })());
    root.append(h("div", { class: "card" }, h("div", { class: "row between wrap" }, h("span", { class: "small muted" }, "Xoá gói không xoá kịch bản."), xoa)));
  };

  /** Lưu cả cấu hình (PUT thay thế) — kiểm bằng kiemCauHinh trước, khoá nút khi đang gọi, 409 → báo tải lại. */
  async function luuCauHinh(nut: HTMLButtonElement, hopL: HTMLElement, dung: () => CauHinhGoi, thanhCong: string): Promise<void> {
    if (nut.disabled) return;
    const cfg = dung();
    const loi = kiemCauHinh(goi, cfg);
    if (loi.length) { hienLoi(hopL, loi, `Chưa lưu được (${loi.length} chỗ cần sửa):`); return; }
    nut.disabled = true;
    const chu = nut.textContent;
    nut.textContent = "Đang lưu…";
    hienLoi(hopL, []);
    try {
      ct = await api<GoiDungChiTiet>("PUT", `/api/goi-seeding/dung/${encodeURIComponent(ct.id)}`, { phienBan: ct.phienBan, cauHinh: cfg });
      toast(thanhCong);
      if (!alive()) return;
      ve();
    } catch (e) {
      const conflict = e instanceof ApiError && e.status === 409;
      hienLoi(hopL, loiTuMayChu(e), conflict ? "Gói vừa được sửa ở nơi khác — tải lại trang rồi sửa tiếp:" : "Chưa lưu được — những gì bạn sửa vẫn còn trên màn hình:");
      nut.disabled = false; nut.textContent = chu;
    }
  }
  ve();
  return () => {};
}
